import { IonCol, IonGrid, IonImg, IonRow } from '@ionic/react';
import React, { useEffect, useState } from 'react';
import { BRAND_DOMAIN, BRAND_NAME } from '../../constants/Branding';
import { ContactList } from '../../constants/FooterView';
import WhatsupImg from '../../assets/images/footer/whatsapp.png';
import gamecura from '../../assets/images/common/gamecura.png';
import './CopyrightV2.scss';
import webtitleImg from '../../assets/images/brand/title.png';
import { NavLink, useHistory } from 'react-router-dom';
import { EXCH_SPORTS_MAP } from '../../constants/ExchangeEventTypes';
import { RootState } from '../../models/RootState';
import { connect } from 'react-redux';
import { EventType } from '../../models/EventType';
import SocialMedia from '../SocialMedia/SocialMedia';
import Above18 from '../../assets/images/icons/above18.svg';
import DisclaimerImg from '../../assets/images/icons/disclaimer.svg';
import { CloseOutlined } from '@material-ui/icons';
import { Button, Drawer } from '@material-ui/core';
import ResponsibleGaming from '../ResponsibleGaming/ResponsibleGaming';
import { DomainConfig } from '../../models/DomainConfig';
import SVLS_API from '../../svls-api';

type FooterProps = {
  eventTypes: EventType[];
  allowedConfig: number;
  domainConfig: DomainConfig;
  langData: any;
  loggedIn: boolean;
};

type responsibleGame = {
  launch: boolean;
  name: string;
};



const Copyright: React.FC<FooterProps> = (props) => {
  const { eventTypes, allowedConfig, domainConfig, langData, loggedIn } = props;
  const [showDisclaimer, setShowDisclaimer] = useState<boolean>(true);
  const [adminWhatsAppNumber, setAmdinWhatsAppNumber] = useState<string>();
  const [whatsappUrl, setWhatsappUrl] = useState('');
  const [responsibleDilalog, setresponsibleDialog] = useState<responsibleGame>({
    launch: false,
    name: null,
  });
  let history = useHistory();

  const footerLinksData = [
    {
      title: 'explore',
      links: [
        {
          title: 'Inplay',
          langKey: 'inplay',
          navigateTo: '/exchange_sports/inplay',
        },
        {
          title: 'Sports Exchange',
          langKey: 'sports_exchange',
          navigateTo: '/exchange_sports/cricket',
        },
        { title: 'Casino', langKey: 'casino', navigateTo: '/casino' },
      ],
    },
    {
      title: 'support',
      links: [
        { title: 'Live Support', langKey: 'live_support', navigateTo: '' },
        { title: 'Help Center', langKey: 'help_center', navigateTo: '' },
        { title: 'Contact Us', langKey: 'contact_us', navigateTo: whatsappUrl }, // Dynamically set URL
      ],
    },
    {
      title: 'about',
      links: [
        { title: 'About Us', langKey: 'about_us', navigateTo: '/about-us' },
        { title: 'Career', langKey: 'career', navigateTo: '' },
      ],
    },
    {
      title: 'legal',
      links: [
        {
          title: 'Terms & Conditions',
          langKey: 't&c',
          navigateTo: '/terms-conditions',
        },
        // { title: 'Privacy Policy',langKey:'privacy_policy', navigateTo: '' },
        {
          title: 'Responsible Gaming',
          langKey: 'responsible_gaming',
          navigateTo: '/responsible-gaming',
        },
      ],
    },
    // {
    //   title: 'Connect with us',
    //   links: [
    //     { title: 'Facebook', navigateTo: '' },
    //     { title: 'Instagram', navigateTo: '' },
    //     { title: 'LinkedIn', navigateTo: '' },
    //     { title: 'Twitter', navigateTo: '' },navigateTo
    //   ],
    // },
  ];

  const getAdminWhatsAppNumber = async () => {
    try {
      let response;
      let url = '';

      if (loggedIn) {
        response = await SVLS_API.get(
          `/account/v2/books/${BRAND_DOMAIN}/contact-list`,
          {
            headers: {
              Authorization: sessionStorage.getItem('jwt_token'),
            },
          }
        );

        if (response.status === 200) {
          const whatsappDetails = response.data.find(
            (contact) => contact?.contactType === 'REGISTRATION_WHATSAPP_LINK'
          );
          url = whatsappDetails?.details || '';
        }
      } else {
        response = await SVLS_API.get(
          `/account/v2/books/${BRAND_DOMAIN}/sdm-contact`
        );
        if (response.status === 200) {
          const whatsappDetails = response.data.find(
            (contact) => contact?.contactType === 'WHATSAPP_NUMBER'
          );

          if (whatsappDetails) {
            url = `http://api.whatsapp.com/send?phone=${whatsappDetails.details}`;
            setWhatsappUrl(url);
          }
        }
      }
    } catch (err) {
      console.error('Error fetching WhatsApp number', err);
    }
  };

  useEffect(() => {
    getAdminWhatsAppNumber();
  }, []);

  const handleClick = (link) => {
    if (link.title == 'Contact Us') {
      window.open(whatsappUrl, '_blank');
    } else {
      history.push(link.navigateTo);
    }
  }

  return (
    <div>
      <IonRow class="copyright-ctn">
        <IonCol
          sizeLg="4"
          sizeSm="12"
          sizeXs="12"
          className="mob-footer-logo-ctn"
        >
          <img className="footer-logo-web web-view" src={webtitleImg} />
          <img className="footer-logo-mob mob-view" src={webtitleImg} />
          <div className="footer-v2">
            <div className="footer-logo-text">
              {langData?.['peak_gaming_srl_caps']}
            </div>
            <div className="footer-logo-text">
              {langData?.['sanjose_costarica_txt']}
            </div>
          </div>
          {/* <div className="above-18-years">
                All above <img src={Above18} /> Years
              </div> */}
          <div className="contact-section">
            {ContactList[BRAND_NAME] ? (
              <>
                <IonImg className="image" src={WhatsupImg} />
                {ContactList[BRAND_NAME]}
              </>
            ) : (
              ''
            )}
          </div>
        </IonCol>

        <IonCol>
          <IonRow className="footer-links-ctn">
            {footerLinksData.map(({ title, links }) => (
              <IonCol
                key={title}
                sizeLg="2"
                sizeSm="2"
                sizeXs="4"
                className="footer-links-list-ctn"
              >
                <div className="footer-link-heading">{langData?.[title]}</div>
                {links.map((link) => (
                  <div
                    key={link.title} 
                    className="footer-link"
                    onClick={() => handleClick(link)}
                  >
                    {langData?.[link.langKey]}
                  </div>
                ))}
              </IonCol>
            ))}
          </IonRow>
        </IonCol>

        {/* <IonCol sizeLg="5" sizeSm="12" sizeXs="12">
            <div className="footer-link-ctn">
              <div className="footer-title sport-algin">Sports</div>
              <div className="footer-link-div-ctn">
                <IonRow>
                  {eventTypes.map((et, eId) =>
                    (allowedConfig & Number(EXCH_SPORTS_MAP[et.slug])) !== 0 ? (
                      <IonCol sizeLg="3" sizeSm="3" sizeXs="3">
                        <div className="footer-link-div">
                          <NavLink
                            className="footer-link"
                            to={`/exchange_sports/${et.slug}`}
                          >
                            {et.name}
                          </NavLink>
                        </div>
                      </IonCol>
                    ) : null
                  )}
                </IonRow>
              </div>
            </div>
          </IonCol> */}
        {/* <IonCol sizeLg="3" sizeSm="12" sizeXs="12">
            <div className="footer-link-ctn">
              <div className="footer-social-title">
                Get connected with us on social networks:
              </div>
              <div className="footer-link-div-ctn">
                <IonCol className="web-social-media-group">
                  <SocialMedia></SocialMedia>
                </IonCol>
              </div>
            </div>
          </IonCol> */}
        {/* <IonCol sizeLg="2" sizeSm="4" sizeXs="4">
        <div className="footer-link-ctn">

          <div className="footer-title">About</div>
          <div className='footer-link-div'>
                  <div className="footer-link" to={`/`}>About Mazaa</NavLink>
                </div>
          <div className='footer-link-div'>
                  <NavLink className="footer-link" to={`/`}>B2B</NavLink>
                </div>
          <div className='footer-link-div'>
                  <NavLink className="footer-link" to={`/`}>Licensing</NavLink>
                </div>
          </div>
        </IonCol> */}
        {/* <IonCol sizeLg="2" sizeSm="4" sizeXs="4">
        <div className="footer-link-ctn">

          <div className="footer-title">Help & Support</div>
          <div className='footer-link-div'>
                  <NavLink className="footer-link" to={`/`}>Help Center</NavLink>
                </div>
          <div className='footer-link-div'>
                  <NavLink className="footer-link" to={`/`}>Live Chat</NavLink>
                </div>
          <div className='footer-link-div'>
                  <NavLink className="footer-link" to={`/`}>Online Slots</NavLink>
                </div>
          <div className='footer-link-div'>
                  <NavLink className="footer-link" to={`/`}>FAQ</NavLink>
                </div>
          <div className='footer-link-div'>
                  <NavLink className="footer-link" to={`/`}>Contact Us</NavLink>
                </div>
          </div>
        </IonCol> */}
        {/* <div className="b-text">PEAK GAMING SRL</div>
        <div>San Jose , Costa Rica </div>
        <div className="above-18-years">
          All above <img src={Above18} /> Years
        </div>
        <div className="contact-section">
          {ContactList[BRAND_NAME] ? (
            <>
              <IonImg className="image" src={WhatsupImg} />
              {ContactList[BRAND_NAME]}
            </>
          ) : (
            ''
          )}
        </div>
        */}
        <div className="copyright-text-ctn border_top">
          {langData?.['copyrights']} {new Date().getFullYear()}, {BRAND_NAME} |{' '}
          {langData?.['all_rights_reserved']}
        </div>
        {/* {showDisclaimer ? (
            <div className="marquee notifications disclaimer">
              <div
                className="info"
                // onClick={() => setShowNotificationModal(true)}
              >
                <img src={DisclaimerImg} />
                {'  '}{langData?.['disclaimer']}
              </div>
              <span>
              {langData?.['copyrights']} {new Date().getFullYear()}, {BRAND_NAME} | {langData?.['all_rights_reserved']}
              </span>
              <div
                className="close-btn"
                onClick={() => setShowDisclaimer(false)}
              >
                <CloseOutlined />
              </div>
            </div>
          ) : null} */}
      </IonRow>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    eventTypes: state.exchangeSports.eventTypes,
    allowedConfig: state.common.allowedConfig,
    domainConfig: state.common.domainConfig,
    langData: state.common.langData,
  };
};

export default connect(mapStateToProps)(Copyright);
